import React from 'react';

import { flagStyles } from '../settings';

const SvgAL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-120px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAL;
